import type { ClientProfileDataResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { formatProfileFullName } from "web_myplann/Profile/Utils/formatProfileFullName";

export const formatProfileName = (
	data?: ClientProfileDataResponseDTO | null,
): string => {
	const name = formatProfileFullName(data);

	if (!name) {
		return "";
	}

	const degreeBefore = data?.degreeBefore?.trim();
	const degreeAfter = data?.degreeAfter?.trim();
	const nameWithDegreeBefore = degreeBefore ? `${degreeBefore} ${name}` : name;

	return degreeAfter
		? `${nameWithDegreeBefore}, ${degreeAfter}`
		: nameWithDegreeBefore;
};
